// @flow

// Libraries
import React, { Element } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { get } from 'lodash';

// Components
import Container from '@material-ui/core/Container';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Logo from '../Logo';

// Styles
import styles from './Footer.scss';

// Types
type PageTypes = {
  className: String,
};

const Footer = ({ className, role }: PageTypes): Element<BottomNavigation> => {
  return (
    <BottomNavigation
      showLabels
      classes={{
        root: classNames(className, styles.Root),
      }}
      variant="dense"
    >
      <Container
        maxWidth="lg"
        classes={{
          root: classNames(styles.Container),
        }}
      >
        <Logo />
        <div className={styles.Items}>
          <BottomNavigationAction
            classes={{
              root: classNames(styles.Item),
            }}
            href="mailto:brand@kaspersky.com"
            label="Contact us"
            disableRipple
          />
          {role && (
            <BottomNavigationAction
              classes={{
                root: classNames(styles.Item),
              }}
              onClick={(): void => {
              }}
              label="Brand team"
              href="https://intranet.kaspersky.com/Pages/ru/Departments/Brand%20Team/Brand-Team.aspx"
              disableRipple
            />
          )}
        </div>
      </Container>
    </BottomNavigation>
  );
};

const mapStateToProps = (state: Object): Object => ({
  role: get(state, 'session.role', ''),
});

const mapDispatchToProps = (dispatch) => ({});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Footer);
